import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialog } from '@angular/material';
import { ShiftsService } from './shifts.service';
import { TimePickerComponent } from '../shared/time-picker/time-picker.component';
import { ShiftsStatusRow, ShiftsRow } from './shifts.defs';
import { Barber } from '../barbers/barber';
import { AppService } from '../app/app.service';

@Component({
  selector: 'app-shifts',
  templateUrl: './shifts.component.html',
  styleUrls: ['./shifts.component.css']
})
export class ShiftsComponent implements OnInit {

	constructor(
		@Inject(MAT_DIALOG_DATA) public date: Date,
		private _ref: MatDialogRef<ShiftsComponent>,
		private _dialog: MatDialog,
		private _shifts: ShiftsService,
		public app: AppService,
	) { }

	rows: ShiftsRow[] = [];
	status: ShiftsStatusRow[] = [];
	valid: boolean = false;
	barbers: {[id: number]: Barber} = {};

	scheduled: {[id: number]: ShiftsRow};

	checkValidity(rows: any[], status: any[]) {
		this.valid = !this.rows.some(row => row._invalid);
	}

	timePick(shift, field: string) {

		const min = new Date(),
			max = new Date();

		min.setHours(8,0,0,0);
		max.setHours(22,0,0,0)

		const v = shift[field],
			ref = this._dialog.open(TimePickerComponent, {
				data: {
					min: min,
					max: max,
					value: v,
					minuteIncrement: 15,
				},
				maxWidth: '98vw',

			});

		ref.afterClosed()
			.subscribe((val: Date) => {
				if (val) {
					const d = new Date(this.date);

					d.setHours(val.getHours(), val.getMinutes(), 0, 0);
					shift[field] = d;
					// make sure the start date and end date have the same DATE portion
					
					this.valid = this._shifts.checkValidity(this.rows, this.status);
				}
			})
	}

	ngOnInit() {
		
		const date = this.date;

		this.rows.length = 0;

		this._shifts
			.byDay(date)
			.subscribe(resp => {
				const y = date.getFullYear(),
					m = date.getMonth(),
					d = date.getDate();

				resp.barbers.forEach(barber => {
					if (barber.id && !barber.system) {
						this.barbers[barber.id] = barber;
					}
				})
				// flip all the dates?
				this.rows = resp.shifts
					.map(shift => {
						if (shift.START) shift.START.setFullYear(y,m,d);
						if (shift.END) shift.END.setFullYear(y,m,d);
						return shift;
					});
				this.status = resp.statusRows;
				this.valid = resp.valid;
				this.scheduled = resp.scheduled;

			})
	}

	save() {
		const save = this._shifts.saveShifts(this.rows, this.status, this.date, this.scheduled);
		if (save) {
			save.subscribe(
				good => this._ref.close(true),
				err => console.warn(err)
			);
		} else {
			this._ref.close(true);
		}
	}

}
